<header class="header">
  <nav class="navbar navbar-expand-lg navbar-light p-0">
    <div class="container">
      <div class="row">
        <div class="collapse navbar-collapse col-md-8 order-2 order-lg-1" id="navMenu">
          <ul class="navbar-nav mr-auto pt-5 pt-lg-0">
            <li class="nav-item">
              <a [href]="'https://franchisecenter.sa/' + currentLang + ''" target="_blank" class="nav-link logo-wrapper">
                <img class="logo" src="./assets/images/Monshaat-white.svg" alt="monshat" />
                <span>{{'Header.slogan' | translate}}</span>
              </a>
              <button class="navbar-toggler ml-3 ml-lg-5" type="button" data-toggle="collapse" data-target="#navMenu"
                aria-controls="navMenu" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
              </button>
            </li>
            <li class="nav-item">
              <a class="nav-link" [href]="'https://franchisecenter.sa/' + currentLang + ''" target="_blank">
                {{"Header.home" | translate}}
              </a>
            </li>

            <li class="nav-item">
              <a class="nav-link"
                [href]="'https://franchisecenter.sa/' + currentLang + '/pages/%D9%86%D8%B8%D8%A7%D9%85-%D8%A7%D9%84%D8%A7%D9%85%D8%AA%D9%8A%D8%A7%D8%B2'"
                target="_blank">
                {{"Header.systems" | translate}}
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [href]="'https://franchisecenter.sa/' + currentLang + '/opportunities'"
                target="_blank">
                {{"Header.franchiseOpportunities" | translate}}
              </a>
            </li>
            <li class="nav-item" [class.active]="isActiveRoute('franchises')">
              <a class="nav-link" [routerLink]="currentLang + '/franchises'">
                {{"Header.Franchises" | translate}}
              </a>
            </li>
            <li class="nav-item" [class.active]="isActiveRoute('requests')">
              <a class="nav-link" [routerLink]="currentLang + '/requests'">
                {{"Header.Requests" | translate}}
              </a>
            </li>

            <li class="nav--dropdown">
              <button (click)="activeMenu = !activeMenu">
                <img src="./assets/images/icons/more.svg" />
              </button>

              <ul [ngClass]="{'active': activeMenu}">
                <li>
                  <a [href]="'https://franchisecenter.sa/' + currentLang + '/emtiyaz-tomoh-program'"
                    target="_blank">{{"Header.VisibleContent" | translate}}</a>
                </li>
                <li>
                  <a [href]="'https://franchisecenter.sa/' + currentLang + '/rehla'"
                    target="_blank">{{"Header.TheJourneyofExcellence" | translate}}</a>
                </li>
                <li>
                  <a [href]="'https://franchisecenter.sa/' + currentLang + '/educational-materials'"
                    target="_blank">{{"Header.AwarenessArticles" | translate}}</a>
                </li>
                <li>
                  <a [href]="'https://franchisecenter.sa/' + currentLang + '/contracts'"
                    target="_blank">{{"Header.ContractForms" | translate}}</a>
                </li>
                <li>
                  <a [href]="'https://franchisecenter.sa/' + currentLang + '/videos'"
                    target="_blank">{{"Header.VisualContent" | translate}}</a>
                </li>
              </ul>
            </li>
          </ul>
        </div> <!-- -->
        <div class="search-profile col-md-4 order-1 order-lg-2 d-flex justify-content-end align-items-center">
          <ul class="d-flex align-items-center justify-content-end ">
            <li class="d-inline-flex mr-3">
              <button class="btn btn-primary with--icon" (click)="createNewFranchise()">
                <!-- <i class="icon-add"></i> -->
                <span>{{"Header.AddFranchise" | translate}}</span>
              </button>
            </li>

            <li class="d-inline-block oneIcon language mr-3">
              <app-language-switcher [currentLang]="currentLang"></app-language-switcher>
            </li>

            <li class="d-inline-flex" *ngIf="userInfo">
              <button class="userMenuBtn" (click)="activeUserMenu = !activeUserMenu">
                <img src="./assets/images/icons/user-profile.svg" />
              </button>

              <ul class="profile--menu" [ngClass]="{'active': activeUserMenu}">
                <li>{{userInfo.userName}}</li>
                <li>
                  <img src="./assets/images/icons/logout.svg" />
                  <span (click)="logout()">{{"Header.LogOut" | translate}}</span>
                </li>
              </ul>
            </li>
          </ul>
        </div>

      </div>

    </div>
  </nav>
</header>

<span class="overLayed active" *ngIf="activeMenu || activeUserMenu"
  (click)="activeMenu = false; activeUserMenu = false"></span>
